export const UNSET_SUBMIT = 'unser-submit';

export default function unsetSubmit() {
  return {
    type: UNSET_SUBMIT,
  };
}
